import React, { useEffect, useState,useCallback } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import LoadingSpinner from "../components/LoadingSpinner";

const PAGE_SIZE = 10;

const WalletHistory = () => {
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pageIndex, setPageIndex] = useState(1);
  const [partnerCode, setPartnerCode] = useState("");
  const [loading, setLoading] = useState(false);
      const apiUrl = process.env.REACT_APP_BASE_URL; // Use the environment variable
  // Get Monday to Sunday of this week by default
 const getDefaultDates = () => {
  const today = dayjs();
  const fromDate = today.subtract(8, 'day'); // 11 Jan if today is 19 Jan
  return {
    from: fromDate.format('YYYY-MM-DD'),
    to: today.format('YYYY-MM-DD'),
  };
};

  const { from: defaultFrom, to: defaultTo } = getDefaultDates();
 const [fromDate, setFromDate] = useState(defaultFrom);  // ✅ Set default directly
   const [toDate, setToDate] = useState(defaultTo);        // ✅ Set default directly
   
  // Set initial default dates on mount
 
    const token = localStorage.getItem("token");

  const fetchData = useCallback(async () => {
    if (!fromDate || !toDate) return;  // Guard clause

    setLoading(true);
    try {
      const response = await axios.post(`${apiUrl}Renew/GetNewWallet`, {
        pageIndex,
        pageSize: PAGE_SIZE,
        fromDate,
        toDate,
        partnerCode: partnerCode || "0",
        countryCode: '',
         creditOrRefund:0, // Assuming this param filters for Credit/Refund types

      }, {
        headers: {
          'accept': '*/*',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        }}
      );

      if (response.data.isSuccess) {
        setData(response.data.getwallet || []);
        setTotalCount(response.data.totalCount || 0);
      }
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
    }, [pageIndex, fromDate, toDate, partnerCode, token]);


 

  // ✅ Fetch data when pageIndex changes OR on initial mount
    useEffect(() => {
      fetchData();
    }, [pageIndex, fetchData]);
  

 const handleSearch = () => {
    if (pageIndex === 1) {
      fetchData();  // If already on page 1, just fetch
    } else {
      setPageIndex(1);  // This will trigger useEffect
    }
  };

  // ✅ DOWNLOAD CSV
  const handleDownload = async () => {
  if (!fromDate || !toDate) {
    alert("Please select date range first");
    return;
  }
  try {
    setLoading(true);
    const response = await axios.post(
      `${apiUrl}Renew/GetNewWallet`,
      {
        pageIndex: 1,
        pageSize: 10,
        fromDate,
        toDate,
        partnerCode: partnerCode || "0",
        countryCode: "",
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        responseType: 'blob',  // ✅ Add this for binary data
      }
    );

    if (!response.data || response.data.size === 0) {
      alert("No data available to download");
      return;
    }

    const csvText = await response.data.text();  // Convert blob to text
    const headers = [
      "Date", "Amount", "Type", "Partner Code", "Balance", "Plan", "Order ID"
    ];
    
    // Parse response data if it's JSON (your current API returns JSON)
    let rows = [];
    try {
      const jsonData = JSON.parse(csvText);
      if (jsonData.isSuccess && jsonData.getwallet) {
        rows = jsonData.getwallet;
      }
    } catch (e) {
      console.error("Parse error:", e);
    }

    if (!rows.length) {
      alert("No data found for download");
      return;
    }

    const csvContent = [
      headers.join(","),
      ...rows.map((item) => [
        `"${item.date || ''}"`,
        `"${item.amount || ''}"`,
        `"${item.type || ''}"`,
        `"${item.description || ''}"`,
        `"${item.balance || ''}"`,
        `"${item.planename || ''}"`,
        `"${item.orderID || ''}"`,
      ].join(","))
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `WalletHistory_${fromDate}_to_${toDate}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);  // ✅ Cleanup memory leak
    
  } catch (err) {
    console.error("Download error:", err);
    alert("Download failed. Check console for details.");
  } finally {
    setLoading(false);
  }
};


  const totalPages = Math.ceil(totalCount / PAGE_SIZE);

  return (
    <div className="max-w-6xl mx-auto p-4">
      <h1 className="text-2xl font-semibold mb-4">Wallet History</h1>

      {/* Filters */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
        <input
          type="text"
          placeholder="Partner Code"
          className="border px-4 py-2 rounded"
          value={partnerCode}
          onChange={(e) => setPartnerCode(e.target.value)}
        />

        <input
          type="date"
          className="border px-4 py-2 rounded"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
        />

        <input
          type="date"
          className="border px-4 py-2 rounded"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
        />

        <button
          onClick={handleSearch}
          className="bg-blue-600 text-white rounded px-4 py-2 hover:bg-blue-700"
        >
          Search
        </button>

        <button
          onClick={handleDownload}
          className="bg-green-600 text-white rounded px-4 py-2 hover:bg-green-700"
        >
          Download CSV
        </button>
      </div>

      {/* Table */}
      {loading ? (
 <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          <LoadingSpinner />
        </div>
              ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border rounded">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-4 py-2">Date</th>
                <th className="px-4 py-2">Amount</th>
                <th className="px-4 py-2">Type</th>
                <th className="px-4 py-2">Partner</th>
                <th className="px-4 py-2">Balance</th>
                <th className="px-4 py-2">Plan</th>
                <th className="px-4 py-2">Order ID</th>
              </tr>
            </thead>
            <tbody>
              {data.length ? (
                data.map((item, index) => (
                  <tr key={index} className="border-t hover:bg-gray-50">
                    <td className="px-4 py-2">{item.date}</td>
                    <td className="px-4 py-2">${item.amount}</td>
                    <td className="px-4 py-2">{item.type}</td>
                    <td className="px-4 py-2">{item.description}</td>
                    <td className="px-4 py-2">{item.balance}</td>
                    <td className="px-4 py-2">{item.planename}</td>
                    <td className="px-4 py-2">{item.orderID}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center py-4 text-gray-500">
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Pagination */}
      <div className="flex justify-between items-center mt-6">
        <button
          disabled={pageIndex === 1}
          onClick={() => setPageIndex((p) => Math.max(p - 1, 1))}
          className="px-3 py-2 bg-gray-200 rounded disabled:opacity-50"
        >
          Previous
        </button>

        <span>
          Page {pageIndex} of {totalPages}
        </span>

        <button
          disabled={pageIndex === totalPages}
          onClick={() => setPageIndex((p) => Math.min(p + 1, totalPages))}
          className="px-3 py-2 bg-gray-200 rounded disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default WalletHistory;
